<script>
  import { domainName, selector, record } from '../stores.js';
</script>

<div class="record-box record-raw">
  <div id="headingRaw" class="box-label">
    <h5>TXT Record Results for DNS Query: <span>{$selector}._domainkey.{$domainName}</span></h5>
    <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseRaw" aria-expanded="true" aria-controls="collapseRaw" aria-label="Close"></button>
  </div>
  <div id="collapseRaw" class="box-detail collapse show" aria-labelledby="headingRaw">
    <div class="color-box">
      <p>{$record.key}</p>
    </div>
  </div>
</div>

<style>

</style>
